import { getCardShortName } from '../../utils/cards';

/** Puce carte humaine ; `led` = le joueur étudié entamait ce pli. */
export default function DiffereStatsCardChip({
  card,
  led,
  title,
}: {
  card: number;
  led?: boolean;
  title?: string;
}) {
  return (
    <span
      className={`differe-stats-chip${led ? ' differe-stats-chip--lead' : ''}`}
      title={title ?? (led ? 'Entame du pli' : undefined)}
    >
      {getCardShortName(card as never)}
    </span>
  );
}

/** Séquence « A → B → C » avec puces colorées selon l'entame. */
export function DiffereStatsCardSequence({
  cardsByTrick,
  ledByTrick,
}: {
  cardsByTrick: number[][];
  ledByTrick?: Array<boolean | undefined>;
}) {
  return (
    <span className="differe-stats-card-sequence">
      {cardsByTrick.map((cards, t) => (
        <span key={t} className="differe-stats-card-sequence-step">
          {t > 0 && <span className="differe-stats-card-sequence-arrow" aria-hidden>→</span>}
          <span className="differe-stats-top-cells">
            {cards.map((c, i) => (
              <DiffereStatsCardChip
                key={`${t}-${c}-${i}`}
                card={c}
                led={ledByTrick?.[t] === true}
              />
            ))}
          </span>
        </span>
      ))}
    </span>
  );
}
